import {
   ApiResponse,
   createApiRequest,
   Header,
   getHeaderFromSessionStorage,
} from "@/api"
import { API_URL, Endpoints } from "@/constants/endpoints"
import { HttpMethods } from "@/constants/globals"

export interface CellResponse {
   id: string
   name: string
   data: {
      status: {
         humanPresence: boolean
         sensorConnected: boolean
         moving: boolean
         lastRead: string
      }
      vitals: {
         heartRate: number
         heartRateStabilityScore: number
         respiratoryRate: number
         respiratoryStabilityScore: number
      } | null
   }
   hasCustomConfigurations: boolean
   vacant: boolean
   maintenance: boolean
}

export async function requestCells(
   levelId: string
): Promise<ApiResponse<CellResponse[]>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.LEVELS}${levelId}/data/`,
      HttpMethods.GET,
      null,
      getHeaderFromSessionStorage(Header.FACILITY_ID)
   )
   return response
}
